<template>
  <div class="register">
    <div class="header">
      <div class="item title">青年创业服务</div>
      <div class="item">
        <div class="text">已有账号?</div>
        <div class="a" @click="login('/login')">立即登录</div>
      </div>
    </div>
    <div class="from">
      <div class="frombox">
        <div class="title">
          <div class="item">找回密码</div>
        </div>
        <!--  -->
        <div class="zy">
<!--          <input type="text" value="" class="line" placeholder="手机号码" />
          <div class="line code">
            <input type="text" value="" class=" " placeholder="验证码" />
            <div class="codetext sbs">获取验证码</div>
          </div>-->
          <input type="text" value="" v-model="username" class="line" placeholder="请输入账号" />
          <input type="text" value="" v-model="oldpassword" class="line" placeholder="请输入旧密码" />
          <input type="password" value="" v-model="password" class="line" placeholder="请输入新密码" />
          <input
            type="password"
            value=""
            class="line"
            v-model="confirmpassword"
            placeholder="请再次输入新密码"
          />
          <div class="btn sbs" @click="affirm">确认</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import cuihaiCombox from "../../components/cuihai-combox/cuihai-combox.vue";
import {httpPut} from "@/utils/request";

export default {
  components: {
    // cuihaiCombox
  },
  data() {
    return {
      curr: 0,
      candidates: ["海东分园", "aa分园", "bb分园"],
      username:'',
      oldpassword:'',
      password:'',
      confirmpassword:''
    };
  },
  methods: {
    login(e) {
      // uni.navigateBack({});
      this.$router.push({ path: e, query: {} });
    },
    affirm(){
      if(this.username == ""){
        this.$message({
          message: '请输入账号!',
          type: 'warning'
        });
        return
      }
      if(this.oldpassword == ""){
        this.$message({
          message: '请输入旧密码!',
          type: 'warning'
        });
        return
      }
      if(!/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/.test(this.password)){
        this.$message({
          message: '新密码由8位数字、大小写字母和特殊符号组成!',
          type: 'warning'
        });
        return
      }
      if(this.confirmpassword != this.password){
        this.$message({
          message: '两次输入密码不一致!',
          type: 'warning'
        });
        return
      }
      let param = {
        username:this.username,
        oldpassword:this.oldpassword,
        password:this.password,
        confirmpassword:this.confirmpassword
      }
      let that = this;
      httpPut('/web/user/webUpdatePassword',param).then(res=>{
        if(res.success){
          that.$message({
            message: res.message,
            type: 'success'
          });
          that.$router.push("/login")
        }else {
          that.$message.error(res.message);
        }
      }).catch(error=>{
        console.log('error')
      })
    },
    chang(e) {
      this.curr = e;
    }
  }
};
</script>

<style scoped lang="scss">
.register {
  background: #f4f5f9;
  min-height: 100vh;
}
.header {
  width: 100vw;
  line-height: 70px;
  display: flex;
  justify-content: space-evenly;
  background-color: #ffffff;
  line-height: 70px;
  .item {
    font-size: 17px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    .text {
      float: left;
    }
    .a {
      color: #00bdff;
      float: left;
    }
    .a {
      cursor: pointer;
    }
  }
  .title {
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
  }
}
.from {
  width: 10rem;
  // height: 854rem;
  overflow: hidden;
  margin: 1.4rem auto;
  background-color: #ffffff;
  .frombox {
    width: 4.2rem;
    margin: 1.1rem auto;
    .title {
      overflow: hidden;
      width: 100%;
      .item {
        float: left;
        font-size: 25px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        margin-right: 25px;
        line-height: 40px;
      }
      .act {
        color: #00bdff;
        border-bottom: 0.02rem solid #00bdff;
      }
    }
    .first {
      margin: 0.3rem 0 0;
    }
    .line {
      width: 90%;
      height: 40px;
      padding: 0 5%;
      margin: 0;
      border: 0.01rem solid #dddddd;
      border-radius: 0.02rem;
      font-size: 16px;
      margin-top: 0.2rem;
    }
    .code {
      overflow: hidden;
      display: flex;
      border: none;
      padding: 0;
      width: 100%;
      input {
        width: 63.875%;
        height: 38px;
        border: 0.01rem solid #dddddd;
        padding: 0;
        padding-left: 5%;
      }
      .codetext {
        width: 31.125%;
        font-size: 16px;
        text-align: center;
        line-height: 40px;
        height: 38px;
        background: #f4f5f9;
        border: 1px solid #dddddd;
        border-radius: 0 2px 2px 0;
        border-left: none;
      }
    }
    .btn {
      width: 100%;
      font-size: 17px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      height: 0.6rem;
      background: #00bdff;
      border-radius: 0.06rem;
      margin-top: 0.57rem;
      text-align: center;
      line-height: 0.6rem;
    }
    .second {
      margin-left: 0.3rem;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #bbbbbb;
      line-height: 40px;
      margin-top: 0.3rem;
      overflow: hidden;
      div {
        float: left;
      }
      .text {
        margin-right: 0.2rem;
      }
      .icon {
        margin-right: 0.11rem;
        width: 16px;
        height: 16px;
        border: 1px solid #bbbbbb;
        margin-top: 11px;
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .header {
    .title {
      font-size: 0.28rem;
    }
    .item {
      font-size: 0.32rem;
    }
  }
  // .from {
  //   width: 690rem;
  //   // height: auto;
  //   overflow: hidden;
  //   .frombox {
  //     width: 630rem;
  //     .title {
  //       overflow: hidden;
  //       width: 100%;
  //       .item {
  //         font-size: 16px;
  //       }
  //     }
  //     .line {
  //       font-size: 14px;
  //     }
  //     .btn {
  //       font-size: 15px;
  //     }
  //   }
  // }
}
</style>
